<div id="emojis" class="popup maintenance-form">
    <emoji-picker></emoji-picker>
    <div class="button-grid">
        <button class="select-button" on:click={close}>Close</button>
    </div>
</div>

<style>

    #emojis {
        display: none;
        width:25vw;
        margin: 0 auto;
    }

    .button-grid {
        padding-top: 0.5vh;
        margin: 0 auto;
    }
</style>

<script>
    import { onMount } from 'svelte';
    import 'emoji-picker-element';
    import { elementDisplay } from './utilities';

    onMount(() => {
        document.querySelector('emoji-picker')
            .addEventListener('emoji-click', event => copy(event));
    })

    function copy(event) {
        navigator.clipboard.writeText(event.detail.unicode);
        close();
    }


    function close() {
        elementDisplay('emojis', 'none');
    }
</script>